/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoVoyageContainersBookingNumberInput = {
    clientMutationId?: string | null;
    voyageSlug?: string | null;
    containerInfo: Array<ContainerInfo>;
};
export type ContainerInfo = {
    containerSlug: string;
    bookingNumber: string;
};
export type VoyageContainerReleaseWizardUpdateBookingMutationVariables = {
    input: infoVoyageContainersBookingNumberInput;
};
export type VoyageContainerReleaseWizardUpdateBookingMutationResponse = {
    readonly infoVoyageContainersBookingNumber: {
        readonly clientMutationId: string | null;
    } | null;
};
export type VoyageContainerReleaseWizardUpdateBookingMutation = {
    readonly response: VoyageContainerReleaseWizardUpdateBookingMutationResponse;
    readonly variables: VoyageContainerReleaseWizardUpdateBookingMutationVariables;
};



/*
mutation VoyageContainerReleaseWizardUpdateBookingMutation(
  $input: infoVoyageContainersBookingNumberInput!
) {
  infoVoyageContainersBookingNumber(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoVoyageContainersBookingNumberPayload",
    "kind": "LinkedField",
    "name": "infoVoyageContainersBookingNumber",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VoyageContainerReleaseWizardUpdateBookingMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VoyageContainerReleaseWizardUpdateBookingMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "124c6629edbb6cb40a4735cc678e34a0",
    "id": null,
    "metadata": {},
    "name": "VoyageContainerReleaseWizardUpdateBookingMutation",
    "operationKind": "mutation",
    "text": "mutation VoyageContainerReleaseWizardUpdateBookingMutation(\n  $input: infoVoyageContainersBookingNumberInput!\n) {\n  infoVoyageContainersBookingNumber(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '855c2971b29491119e8c29251c66f560';
export default node;
